import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { TreeCommandsHandler } from '../../tree/tree-commands-handler';
import { TreeFilterHandler } from '../../tree/tree-filter-handler';
import { Subject, BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, filter, delay } from 'rxjs/operators';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'selector-toolbar',
    templateUrl: './selector-toolbar.component.html',
    styleUrls: ['./selector-toolbar.component.scss']
})
export class SelectorToolbarComponent implements OnDestroy, OnInit {
    @Input() disabled: boolean;
    @Input() treeCommandsHandler: TreeCommandsHandler;
    @Input() treeFilterHandler: TreeFilterHandler;
    @Input() title: string;
    @Input() status;
    @Input() selectedNodesNumber;
    @Input() inputSearchText: string;
    @Input() visibleSelectAllButton: boolean;

    @Output() notifyStatus = new EventEmitter();
    @Output() notifyFocus = new EventEmitter<boolean>();

    @Output() loading = new BehaviorSubject<boolean>(false);

    private status$ = new Subject<boolean>();
    private searchSub$ = new Subject<string>();

    applyFilter(value: string) {
        this.searchSub$.next(value);
    }

    ngOnDestroy() {
        this.searchSub$.complete();
        this.status$.complete();
    }

    ngOnInit() {
        this.searchSub$.pipe(
            filter(Boolean),
            debounceTime(500),
            distinctUntilChanged(),
            tap(() => {
                this.loading.next(true);
            }),
            delay(10) /* needed to update the ui with the loader */
        ).subscribe((filterValue: string) => {
            this.treeFilterHandler.applyFilter();
            this.loading.next(false);
        });

        this.status$.pipe(
            tap(() => {
                this.loading.next(true);
            }),
            delay(10) /* needed to update the ui with the loader */
        ).subscribe((status: boolean) => {
            this.notifyStatus.emit(status);
            this.loading.next(false);
        });
    }

    onFocus() {
        this.notifyFocus.emit(true);
    }

    onBlur() {
        this.notifyFocus.emit(false);
    }
}
